import { useState } from 'react'
import { useComposers } from '@/hooks/useComposers'
import { ComposersTable, type ComposerFilter } from '@/components/features/composers/ComposersTable'

export function Composers() {
  const { data: composers, isLoading, error } = useComposers()
  const [filter, setFilter] = useState<ComposerFilter>('all')

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-muted-foreground">Loading composers...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6">
        <h2 className="font-semibold text-destructive">Failed to load composers</h2>
        <p className="mt-1 text-sm text-muted-foreground">{error.message}</p>
      </div>
    )
  }

  if (!composers || composers.length === 0) {
    return (
      <div className="space-y-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Composers</h1>
          <p className="text-muted-foreground mt-2">No composers found.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Composers</h1>
        <p className="text-muted-foreground mt-2">
          Browse and manage composer records. Click a row to view details.
        </p>
      </div>
      <ComposersTable composers={composers} filter={filter} onFilterChange={setFilter} />
    </div>
  )
}
